/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { SearchDropdown } from '@iris-platform/iris-react-ui';
import {
  pathOr,
} from 'ramda';
import { SEARCH_TEAMS, getAllTeamRoles } from './queries';
import LoadingPanel from '../../../components/ApplicationsTable/Loading';

/* eslint no-use-before-define: 0 */
class CopyRoleForm extends React.PureComponent {
  render() {
    const {
      onRoleSelection,
      roleTeam, errorMessage, onTeamSelect,
    } = this.props;
    return (
      <div>
        <p>{errorMessage}</p>

        <Query
          query={SEARCH_TEAMS}
          notifyOnNetworkStatusChange
          variables={{ filter: '', skip: 0, limit: 100 }}
        >
          {({ data, loading, error }) => {
            if (error) {
              return <h1>Oops, got error...</h1>;
            }
            if (loading) {
              return (
                <SearchDropdown
                  optionsList={{ code: 'Loading', description: 'Loading' }}
                  label="Role"
                  name="role"
                  placeholder="Select Role"
                />
              );
            }
            return (
              <div>
                <SearchDropdown
                  optionsList={data.searchTeams.map(team => (
                    { code: team.team_id, description: team.display_name }
                  ))}
                  label="Team"
                  name="team"
                  placeholder="Select Team or Personal"
                  onSelect={option => onTeamSelect(option)}
                />
              </div>
            );
          }}
        </Query>
        <br />
        <Query
          query={getAllTeamRoles}
          notifyOnNetworkStatusChange
          variables={{ teamID: pathOr('', ['code'], roleTeam) }}
        >
          {({ data, loading, error }) => {
            if (error) {
              return <h1>Oops, got error...</h1>;
            }
            if (loading) {
              return (
                <SearchDropdown
                  optionsList={{ code: 'Loading', description: 'Loading' }}
                  label="Role"
                  name="role"
                  placeholder="Select Role"
                />
              );
            }

            return (
              <div>
                <SearchDropdown
                  optionsList={data.allTeamRoles.map(roles => (
                    {
                      code: roles.roleIdentifier.name,
                      description: `${roles.roleIdentifier.displayName} (${roles.roleIdentifier.name})`,
                      team: roles.roleIdentifier.team,
                      displayName: roles.roleIdentifier.displayName,
                      permissions: roles.permissions,
                    }
                  ))}
                  label="Role"
                  name="role"
                  placeholder="Select Role"
                  onSelect={option => onRoleSelection(option)}
                />
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default CopyRoleForm;

CopyRoleForm.propTypes = {
  roleTeam: PropTypes.string.isRequired,
  onTeamSelect: PropTypes.func.isRequired,
  onRoleSelection: PropTypes.func.isRequired,
};
